import * as store from '@attain-apps/fe/web/main/lib/store'

import type { State } from './state'
import type { Edit } from './types'

/** Core actions for the Space report configuration plugin. */
// NOTE: intentionally missing return type so that type can be inferred
export function getActionsConfig() {
  return {
    /** Applies a partial change to one report's configuration. */
    edit: store.actions.request({
      input: store.actions.Data.asIs<Edit.ForReport>(),
      output: store.actions.Data.NONE,
    }),
    /** Clears every stored report configuration. */
    reset: store.actions.request({
      input: store.actions.Data.NONE,
      output: store.actions.Data.NONE,
    }),
  } as const satisfies store.actions.Config.Constraint<State>
}
